import { render, staticRenderFns } from "./LegendBar.vue?vue&type=template&id=0489855a&scoped=true"
import script from "./LegendBar.vue?vue&type=script&lang=js"
export * from "./LegendBar.vue?vue&type=script&lang=js"
import style0 from "./LegendBar.vue?vue&type=style&index=0&id=0489855a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0489855a",
  null
  
)

export default component.exports